import { render, staticRenderFns } from "./card-producto-carrito.vue?vue&type=template&id=4b5e64a3&scoped=true&"
import script from "./card-producto-carrito.vue?vue&type=script&lang=js&"
export * from "./card-producto-carrito.vue?vue&type=script&lang=js&"
import style0 from "./card-producto-carrito.vue?vue&type=style&index=0&id=4b5e64a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e64a3",
  null
  
)

export default component.exports